import { useGetAuthSessionQuery } from '@/api/serverApi'
import LoginForm from '@/components/forms/auth/LoginForm'
import { Meta, useSession } from '@cfs-fixings/shared'
import { useNavigate } from 'react-router-dom'
import loginProfileImage from '@/assets/login-profile.webp'
import loginImage from '@/assets/login-image.webp'

const textSpecs = {
  testimonial: {
    text: 'One of the most frustrating things about pre-planning is not having the right information.',
    name: 'Name Surname',
    role: 'CEO',
    company: 'Company Name',
  },
}

function LoginPage () {
  const navigate = useNavigate()

  useSession({
    getData: useGetAuthSessionQuery,
    onValidSession: () => {
      navigate('/designs')
    },
  })

  return (
    <>
      <Meta title="Login" />

      <div className="flex justify-center w-full lg:w-[600px] px-[30px]">
        <div className="absolute top-[20%]">
          <LoginForm />
        </div>
      </div>

      <div className="bg-gray-50 border-l border-gray-500 px-[96px] grow hidden lg:flex flex-col">
        <div className="max-w-[720px] flex grow self-center items-center">
          <div>
            <p className="text-gray-850 text-[24px]">
              &ldquo;{textSpecs.testimonial.text}&rdquo;
            </p>

            <div className="flex gap-[16px] mt-[20px]">
              <img
                src={loginProfileImage}
                alt=""
                className="rounded-full w-[48px] h-[48px] object-cover"
              />
              <div className="space-y-[4px] text-gray-900">
                <p className="font-medium text-[18px]">
                  {textSpecs.testimonial.name}
                </p>
                <p className="text-[13px] font-mono uppercase">
                  {textSpecs.testimonial.role}, {textSpecs.testimonial.company}
                </p>
              </div>
            </div>

            <img
              src={loginImage}
              alt=""
              className="mt-[80px]"
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default LoginPage
